const state = {
  sortItems: [
    {
      names: ['name.asc', 'title.asc', 'slug.asc', 'email.asc', 'status.asc', 'article.asc'],
      sort(sortArray, key) {
        return sortArray.sort((a, b) => {
          if (a[key] === null) return 1;
          if (b[key] === null) return -1;

          if (isNaN(a[key]) && isNaN(b[key])) {
            return a[key].toLowerCase() > b[key].toLowerCase() ? 1 : -1;
          } else {
            return a[key] - b[key]
          }
        })
      }
    },
    {
      names: ['name.desc', 'title.desc', 'slug.desc', 'email.desc', 'status.desc', 'article.desc'],
      sort(sortArray, key) {
        return sortArray.sort((a, b) => {
          if (a[key] === null) return -1;
          if (b[key] === null) return 1;

          if (isNaN(a[key]) && isNaN(b[key])) {
            return a[key].toLowerCase() > b[key].toLowerCase() ? -1 : 1;
          } else {
            return b[key] - a[key]
          }
        })
      }
    },
    {
      names: ['sort.asc', 'activity.asc', 'deleted_at.asc', 'id.asc', 'priority.asc'],
      sort(sortArray, key) {
        return sortArray.sort((a, b) => {
          return a[key] - b[key]
        })
      }
    },
    {
      names: ['created_at.asc'],
      sort(sortArray, key) {
        return sortArray.sort((a, b) => {
          return Date.parse(b[key]) - Date.parse(a[key])
        })
      }
    },
    {
      names: ['created_at.desc'],
      sort(sortArray, key) {
        return sortArray.sort((a, b) => {
          return Date.parse(a[key]) - Date.parse(b[key])
        })
      }
    },
  ]
}

const actions = {}
const mutations = {}

const getters = {
  sortItems: state => state.sortItems
}

export default {
  state,
  actions,
  mutations,
  getters,
}